(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldApproverSelector', fbFieldApproverSelector);

    function fbFieldApproverSelector($timeout, lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                eventHandler: '&'
            },
            require: 'ngModel',
            templateUrl: 'common/libraries/formBuilder/fields/fieldApproverSelector',
            controller: fbFieldApproverSelectorCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;

                ctrl.$render = function (viewValue) {
                    vm.model = vm.setInitialModel(ctrl.$modelValue);
                }

                vm.commitChange = function () {
                    ctrl.$setViewValue(vm.model);
                }
            }
        };
    }

    function fbFieldApproverSelectorCtrl(lodash, FormBuilderService, $scope, GenericModel, ActionCommon, $timeout, FbSelectService) {
        var vm = this;
        this.$onInit = function() {
            vm.selectizes = null;
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);
            vm.additionalOptions = {};
            FbSelectService.initTemplateCall(vm.element.options, vm.additionalOptions);

            vm.roles_ds = lodash.get(vm.element, 'options.datasource.roles', []);
            vm.approvers_ds = lodash.get(vm.element, 'options.datasource.approvers', {});


            console.log('fbFieldApproverSelector', vm.element);
            if (lodash.has(vm.element, 'options.datasource.optgroup_data')) {
                vm.additionalOptions = {optgroups: vm.element.options.datasource.optgroup_data};
            }

            vm.setInitialModel = function (modelValue) {
                var result = {};
                lodash.forEach(vm.roles_ds, function (value) {
                    var id = value.id;
                    if (lodash.has(modelValue, id)) {
                        result[id] = modelValue[id];

                        lodash.set(result[id], 'main', lodash.get(modelValue[id], 'main', null));
                        lodash.set(result[id], 'proxy', lodash.get(modelValue[id], 'proxy', null));
                    } else {
                        result[id] = {
                            value: id,
                            main: null,
                            proxy: null,
                        };
                    }
                });
                return result;
            }

            vm.config =
                angular.merge(
                    {
                        highlight: true,
                        create: false,
                        labelField: 'label',
                        valueField: 'value',
                        maxItems: 1,
                        searchField: ['label'],
                        onInitialize: function (selectize) {
                            // vm.selectize = selectize;
                            // $timeout(function() {
                            //     if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                            //         vm.selectize.disable();
                            //     }
                            // });
                        },
                    },
                    lodash.get(vm.element, 'options.selectize', {}),
                    vm.additionalOptions
                );
        }
    }
})();